import { DSResource, DSTextPage } from 'shared-definitions/types'
import { ApiComponent, ApiTextPageProps } from 'data-source/types.wp'
import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { metaMapper, MetaMapperOpts } from 'data-source/mappers/metaMapper'
import { postSectionsMapper } from 'data-source/mappers/postSectionsMapper'

interface TextPageMapperOpts<T extends DSResource, A extends ApiComponent> extends MetaMapperOpts {
  pagePath: string
  ampPagePath: null | string
  componentItemMapper: (input: A) => T | T[]
}

export function textPageMapper<T extends DSResource, A extends ApiComponent>(
  input: ApiTextPageProps<A>,
  opts: TextPageMapperOpts<T, A>
): DSTextPage<T> {
  return {
    meta: metaMapper({ ...input, content: {} }, ['Features'], opts),
    head: headPropsMapper(input.head),
    ampPagePath: opts.ampPagePath,
    pagePath: opts.pagePath,
    sections: input.sections ? postSectionsMapper(input.sections) : null,
    title: input.content.title,
    blocks: input.content.content.flatMap(opts.componentItemMapper),
    resource: 'text-page',
  }
}
